import React, { Component } from 'react';

import Landing from './Containers/LandingPage/LandingPage';
import { connect } from "react-redux";
import { auth, messaging } from "./Firebase/firebase";
import { Switch, Redirect, Route } from "react-router-dom";
import {  database, isSpported } from "./Firebase/firebase";
import * as actionCreators from "./Store/actions/index";
import SearchPage from "./Containers/SearchPage/SearchPage";
import DetailPage from "./Containers/DetailPage/DetailPage";
import WishList from "./Containers/WishList/WishList";
import DealerPage from "./Containers/DealerPage/DealerPage";
import Profile from "./Containers/Profile/Profile";
import Messages from "./Containers/Messages/Messages";
import Chat from "./Containers/Chats/Chats";
import Layout from './HOC/Layout/Layout';

class App extends Component {

  componentDidMount() {

    auth.onAuthStateChanged((user) => {
      if (user && user.emailVerified) {
        localStorage.setItem('user', user.email)
        this.props.onSuccessAuth(user)
        user.getIdTokenResult(true).then(res => {
          this.props.onGetWihsList(res.token)
          localStorage.setItem('idToken', res.token)

          setTimeout(() => {
            localStorage.removeItem('idToken')
            user.getIdToken(true).then(newToken => {
              localStorage.setItem('idToken', newToken)
            })
          }, 3600 * 1000)
          this.props.onGetCurrentLogeUser(res.token)
        })

        if (isSpported()) {
          messaging.onTokenRefresh(() => {
            messaging.getToken().then((refreshedToken) => {
              localStorage.setItem('fcmToken', refreshedToken)
              let uid = localStorage.getItem('uid')
              database.ref(`recivers/${uid}`).set({ token: refreshedToken, id: uid })
                .then(res => console.log('sentToFIreDataBase', res))

            }).catch((err) => {
              console.log('Unable to retrieve refreshed token ', err);
            });
          });
        }
      } else {
        localStorage.removeItem('idToken')
      }
    });
  }

  render() {
    let route = null;
    if (this.props.userEmail) {
      route = (
        <Switch>
          <Route path='/' exact component={Landing} />
          <Route path='/Search' exact component={SearchPage} />
          <Route path='/Detail' exact component={DetailPage} />
          <Route path='/WishList' exact component={WishList} />
          <Route path='/Dealer' exact component={DealerPage} />
          <Route path='/Profile' exact component={Profile} />
          <Route path='/Messages' exact component={Messages} />
          <Route path='/Chat' exact component={Chat} />
          <Redirect to='/' />
        </Switch>);
    } else {
      route = (
        <Switch>
          <Route path='/' exact component={Landing} />
          <Route path='/Search' exact component={SearchPage} />
          <Route path='/Detail' exact component={DetailPage} />
          <Route path='/Dealer' exact component={DealerPage} />
          <Redirect to='/' />
        </Switch>);
    }
    return (
      <div >
        <Layout>
          {route}
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userEmail: state.Auth.userEmail
  }
};

const mapDispatchToProps = dispatch => {
  return {
    onSuccessAuth: (user) => { dispatch(actionCreators.successAuth(user)) },
    onGetCurrentLogeUser: (token) => { dispatch(actionCreators.getCurrentLogedUserData(token)) },
    onGetWihsList: (token) => { dispatch(actionCreators.getWishList(token)) },
    onUserNotVerfiy: (message) => { dispatch(actionCreators.failAuth(message)) },
    onlogOut: () => { dispatch(actionCreators.logoutAuth()) }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
